module.exports = __webpack_public_path__ + "static/media/petlee-2.ddb3d045.png";